export default () => {
    let allHtml = document.querySelector('html'); 

    const singleVideo = document.querySelectorAll('.js-SingleVideo');
    
    if(singleVideo){
      singleVideo.forEach( el => {
        const media = el.querySelector('.js-SingleVideoPlayer'); 
        const play = el.querySelector('.js-playVideobtn'); 
        const stop = el.querySelector('.js-stopVideobtn'); 

        const openModal = el.querySelector('.js-modal');  
        const modal = el.querySelector('.js-ModalBlock'); 
      
        //Modale
        let closenModal = modal.querySelector('.js-ModalBlock-Close');  
        if(openModal){
            openModal.addEventListener('click', function() { 
                allHtml.style.overflow = 'hidden';
                modal.classList.add('is-modal-open');
                playMedia();
            }) 
        }
        if(closenModal){
                closenModal.addEventListener('click', function(){
                closeModal();
            })              
        }

        const closeModal = () => {
            modal.classList.remove('is-modal-open');
            allHtml.style.overflow = 'auto';
            stopMedia();
        } 
        
        //Video
        media.removeAttribute('controls'); 
        play.addEventListener('click', playMedia);
        media.addEventListener('click', playMedia)

        function playMedia() {
          if(media.paused) { 
              console.log(play)
              play.classList.add('is-playing');
              media.play();
            } else { 
                console.log(play)
            play.classList.remove('is-playing');
            media.pause();
          }
        }
        
        stop.addEventListener('click', stopMedia);
        media.addEventListener('ended', stopMedia);

        function stopMedia() {
          media.pause();
          media.currentTime = 0; 
        }
      });
    }
}